import { apiBaseUrl } from 'app/src/msw/shopping/api/apiBaseUrl'
import type { shoppingApi } from 'app/src/services/welfareportal'
import { http, HttpResponse } from 'msw'

export const activateProductMulti = http.post<object, shoppingApi.ActivateRequest, shoppingApi.ActivateResult>(
  apiBaseUrl + '/activate/multi',
  async ({ request }) => {
    const bodyReq = await request.json()

    if (bodyReq.product.productId == 'WI2EPG9I')
      //MULTIVOUCHER
      return HttpResponse.json({
        method: 'GET',
        url: 'http://localhost:3001/#/shop/direct/multivoucher/MULTIVOUCHER.DRAFT',
      })
  },
)
